import {
  ArchiveBoxIcon,
  ArrowPathIcon,
  ArrowUturnLeftIcon,
  CheckCircleIcon,
  EyeIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid";

// A decision step looks like the action it is (DecisionPanel's choices, the help guides' copies of them): the colour
// of where it leads, with its icon; `on` when chosen. Any other step (back to waiting, a restore) is neutral.
const STEP_LOOKS = {
  UNDER_REVIEW: { Icon: EyeIcon, idle: "bg-blue-50 text-blue-800 ring-blue-600/25", hover: "hover:bg-blue-100", on: "bg-blue-600 text-white ring-blue-600" },
  APPROVED: { Icon: CheckCircleIcon, idle: "bg-emerald-50 text-emerald-800 ring-emerald-600/25", hover: "hover:bg-emerald-100", on: "bg-emerald-600 text-white ring-emerald-600" },
  CHANGES_REQUESTED: { Icon: ArrowUturnLeftIcon, idle: "bg-violet-50 text-violet-800 ring-violet-600/25", hover: "hover:bg-violet-100", on: "bg-violet-600 text-white ring-violet-600" },
  DECLINED: { Icon: XCircleIcon, idle: "bg-red-50 text-red-700 ring-red-600/25", hover: "hover:bg-red-100", on: "bg-red-600 text-white ring-red-600" },
  ARCHIVED: { Icon: ArchiveBoxIcon, idle: "bg-slate-100 text-slate-700 ring-slate-400/30", hover: "hover:bg-slate-200", on: "bg-slate-700 text-white ring-slate-700" },
};
const OTHER_STEP = { Icon: ArrowPathIcon, idle: "bg-white text-slate-700 ring-slate-300", hover: "hover:bg-slate-50", on: "bg-slate-900 text-white ring-slate-900" };

export const stepLook = (code) => STEP_LOOKS[code] || OTHER_STEP;
